import React from 'react'

export const Spinner = () => {
  return (
    <div><div className='spinner '></div></div>
  )
}
